import { API } from 'aws-amplify';

export const getRedbookData = async (query) => {
  return await API.get('MyAPI', `/lookups/redbook`, {
    queryStringParameters: {
      ...query,
    },
  });
};
